var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v(_vm._s(_vm.$t("message.agentFeature"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.freeAgentCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.freeAgentCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "freeAgentCount", $$v)
                },
                expression: "featureForm.freeAgentCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.agentCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.agentCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "agentCount", $$v)
                },
                expression: "featureForm.agentCount",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }